import {Button, Divider} from 'lark';
import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {LOGIN_TO} from '~/constant/login';
import './index.less';

const LoginFooter = props => {
    const {to, agent: {isMobile}} = props;
    const className = isMobile ? 'h5-login-footer' : 'web-login-footer';
    // const showReset = to === LOGIN_TO.ACCOUNT_PASSWORD;

    // cas移除重置密码功能
    const showReset = false;

    return (
        <div className={className}>
            {showReset && (
                // <Button type="link" href="/cas/reset">
                //     <span className="login-footer-button-text">重置密码</span>
                // </Button>
                <Link to="/cas/reset" className="footer-link">
                    <span className="login-footer-button-text">重置密码</span>
                </Link>
            )}
            {showReset && isMobile && <Divider type="vertical" />}
            {/* <Button type="link" href="/cas/help">
                <span className="login-footer-button-text">帮助中心</span>
            </Button> */}
            <Link to="/cas/help" className="footer-link">
                <span className="login-footer-button-text">帮助中心</span>
            </Link>
        </div>
    );
};

LoginFooter.propTypes = {
    to: PropTypes.string.isRequired,
    agent: PropTypes.shape({
        isMobile: PropTypes.bool.isRequired
    }).isRequired,
};
export default connect(({agent}) => ({agent}))(LoginFooter);
